
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 147.45 318.15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Calque 2"}},[_c('path',{attrs:{"fill":"#5e7e8f","d":"M67.29 227.62h12.88v90.53H67.29z"}}),_c('path',{staticClass:"poly",attrs:{"fill":"#9db56b","d":"M73.72.7v226.92H0L73.72.7z"}}),_c('path',{staticClass:"poly",attrs:{"fill":"#b6c891","d":"M147.15 227.7L73.42.2v227.5"}})])])
          )
        }
      }
    